import i18n from "i18next";
import Backend from "i18next-xhr-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

const fallbackLng = ["engv01"];
// chiv11 y japv11 quedan ocultos: para volver a habilitarlos, sumarlos de nuevo
// a esta lista y descomentar sus botones en Header, Footer, FooterSenaForm y Legal.
// Importante: NO alcanza con dejarlos afuera de los botones. Desde que el idioma
// se detecta por localStorage, sumar un codigo a esta lista basta para que alguien
// que lo eligio en su ultima visita arranque en ese idioma sin boton para salir.
const availableLanguages = ["engv01", "espv01", "porv01"];

const options = {
  // order and from where user language should be detected.
  // localStorage y cookie van primero para que el idioma elegido sobreviva a un
  // reload. El resto casi nunca acierta: los codigos del navegador ("pt-BR") no
  // coinciden con las carpetas versionadas ("porv01"), asi que en la primera
  // visita se cae a fallbackLng (ingles), que es el comportamiento de siempre.
  order: [
    "localStorage",
    "cookie",
    "navigator",
    "htmlTag",
    "path",
    "subdomain",
  ],

  // keys or params to lookup language from
  lookupQuerystring: "lng",
  lookupCookie: "i18nextSenaV2",
  lookupLocalStorage: "i18nextLngSenaV2",
  lookupFromPathIndex: 0,
  lookupFromSubdomainIndex: 0,

  // cache user language on
  caches: ["localStorage", "cookie"],
  excludeCacheFor: ["cimode"], // languages to not persist (cookie, localStorage)

  // optional expire and domain for set cookie
  cookieMinutes: 10,
  cookieDomain: "sena.cl",

  // optional htmlTag with lang attribute, the default is:
  htmlTag: document.documentElement,

  // only detect languages that are in the whitelist
  checkWhitelist: true,
};

i18n
  .use(Backend) // load translation using xhr -> see /public/locales. We will add locales in the next step

  .use(LanguageDetector) // detect user language

  .use(initReactI18next) // pass the i18n instance to react-i18next.

  .init({
    fallbackLng, // if user computer language is not on the list of available languages, than we will be using the fallback language specified earlier
    debug: false,
    whitelist: availableLanguages,
    detection: options,
    // Sin `lng` fijo: cuando se define, i18next lo usa y nunca llama al
    // LanguageDetector, asi que el idioma elegido se perdia en cada reload.
    // Ahora el detector lee el localStorage y fallbackLng cubre el resto.
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true, //   <---- this will do the magic
    },
  });

export default i18n;
